import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { useGetUser } from '../../contexts/user';

export function RedirectToPage({ page }) {
  const { push } = useHistory();

  useEffect(() => {
    push(page);
  }, [page, push]);

  return null;
}

export default function AuthenticatedLayout({ children }) {
  const { userDetails } = useGetUser();
  if (!userDetails.username) return <></>;

  return (
    <div className={`grid min-h-max`}>
      <AuthenticatedTemplate>
        <main>{children}</main>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <RedirectToPage page="/login" />
      </UnauthenticatedTemplate>
    </div>
  );
}
